import React,{Component} from 'react';
import ReactDOM from 'react-dom';


import pack from '@/languages/pack'

import createLogHistoryPannel from 'components/zHistoryLog/createApi';

// let notification = null;
// Notification.newInstance({position: 'bottomRight'}, n => notification = n);

global.historyLogLang = {
  lang:'zh_CN',
  setLang:function( lang ){
    this.lang = lang || 'zh_CN';
  },
  template:function(key){
    return pack[this.lang.replace(/[\_\-]/,'').toLocaleLowerCase()][key]
  }
}
export const historyLog =  (option) =>{
  let { locale,record,url } = option
  let { busiObjId,busiObjCode,busiObjName,operationDate:currentTime,busiObjTypeCode } = record
  historyLogLang.setLang(locale);
  if(!busiObjId){
    console.error('没有busiObjId字段')
  }
  createLogHistoryPannel({url,busiObjId,busiObjCode,busiObjName,busiObjTypeCode,currentTime,record})
}
export default historyLog

import {
  JsonViewerComparePannel,
  JsonViewerPannel
} from 'components/zTestJson/JsonViewerPannel'


// {/* <JsonViewerComparePannel leftTitle={leftTitle} jsonDataLeft={leftJson} rightTitle={rightTitle} jsonDataRight={rightJson} /> */}
export function jsonViewer(option){
  if(typeof document == 'undefined'){return}
  let { locale , ...otherProps } = option;
  historyLogLang.setLang(locale);
  let div = document.createElement('div')
  document.body.appendChild(div)
  function destory(){
    ReactDOM.unmountComponentAtNode(div);//也可通过childNodes来实现纯js卸载
    document.body.removeChild(div)
  }
  function render(){
    ReactDOM.render(<JsonViewerPannel destory={destory} {...otherProps} />,div);
  }
  render()
}

export function jsonViewerCompare(option){
  if(typeof document == 'undefined'){return}
  let { locale , ...otherProps } = option;
  historyLogLang.setLang(locale);
  let div = document.createElement('div')
  document.body.appendChild(div)
  function destory(){
    ReactDOM.unmountComponentAtNode(div);//也可通过childNodes来实现纯js卸载
    document.body.removeChild(div)
  }
  function render(){
    ReactDOM.render(<JsonViewerComparePannel destory={destory} {...otherProps} />,div);
  }
  render()
}


// WEBPACK FOOTER //
// ./src/main.js